import uniqueId from 'lodash/uniqueId';

export const involvedList = [
  {
    label: 'Examinee(s)',
    key: uniqueId('involved-'),
    value: 'examinee',
    flag: 'allowExamineeFlag',
  },
  {
    label: 'Entire room(s)',
    key: uniqueId('involved-'),
    value: 'room',
    flag: 'allowRoomFlag',
  },
  {
    label: 'Entire site(s)',
    key: uniqueId('involved-'),
    value: 'test_center',
    flag: 'allowTestCenterFlag',
  },
];
